import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { CashBreakdown } from "@/components/cash/CashBreakdown";
import { api, brl, errMsg, PAY_LABELS } from "@/lib/api";
import { toast } from "sonner";

export function CloseCashDialog({ open, onOpenChange, cash, onClosed }) {
  const summary = cash?.summary;
  const [counted, setCounted] = useState({});
  const [notes, setNotes] = useState("");
  const expected = summary ? { ...summary.by_method, dinheiro: summary.expected_cash } : {};
  const methods = Object.keys(expected).filter((m) => m === "dinheiro" || expected[m]);
  const diff = (m) => (counted[m] === undefined || counted[m] === "" ? null : Math.round((Number(counted[m]) - expected[m]) * 100) / 100);
  const submit = async () => {
    try {
      const vals = Object.fromEntries(methods.filter((m) => m !== "dinheiro" && counted[m] !== undefined && counted[m] !== "").map((m) => [m, Number(counted[m])]));
      const { data } = await api.post("/cash/close", { closing_amount: Number(counted.dinheiro) || 0, counted: vals, notes, session_id: cash.session.id });
      toast.success("Caixa fechado");
      setCounted({});
      setNotes("");
      onClosed(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="close-cash-modal">
        <DialogHeader><DialogTitle>Fechar caixa · conferência</DialogTitle><DialogDescription>Informe o valor contado de cada forma de pagamento. Campos vazios são considerados conferidos.</DialogDescription></DialogHeader>
        {cash && <div className="rounded-lg bg-muted/60 p-3 text-sm"><CashBreakdown session={cash.session} summary={summary} /></div>}
        <div className="space-y-2">
          <div className="grid grid-cols-[1fr_100px_110px_90px] gap-2 text-xs text-muted-foreground"><span>Forma</span><span className="text-right">Esperado</span><span>Contado</span><span className="text-right">Diferença</span></div>
          {methods.map((m) => (
            <div key={m} className="grid grid-cols-[1fr_100px_110px_90px] items-center gap-2 text-sm">
              <span>{PAY_LABELS[m]}</span>
              <span className="text-right font-mono">{brl(expected[m])}</span>
              <Input type="number" step="0.01" value={counted[m] ?? ""} onChange={(e) => setCounted((c) => ({ ...c, [m]: e.target.value }))} className="h-9 font-mono" data-testid={`close-count-${m}`} />
              <span className={`text-right font-mono ${diff(m) < 0 ? "text-red-500" : diff(m) > 0 ? "text-emerald-500" : ""}`} data-testid={`close-diff-${m}`}>{diff(m) === null ? "—" : brl(diff(m))}</span>
            </div>
          ))}
        </div>
        <Textarea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Observações do fechamento" data-testid="close-notes-input" />
        <DialogFooter><Button variant="destructive" onClick={submit} disabled={counted.dinheiro === undefined || counted.dinheiro === ""} data-testid="close-cash-confirm-btn">Fechar caixa</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
